"use client";

import { c as _c } from "react/compiler-runtime";
import { IconButton } from "@mui/material";
import Image from "next/image";
import { useState } from "react";
import { colorSurfaceSurface } from "../../../../(styles)/variables";
import BottomSheet from "../../../../../components/ui/BottomSheet";
import useDeviceType from "../../../../../lib/constants/useDeviceType";
import FccBottomSheet from "./FccBottomSheet";
import { pushGtmEvent } from "../../../../../lib/utils/gtmEventHandler";
const FccModal = t0 => {
  const $ = _c(15);
  const {
    isFCCMember,
    digitalProfile,
    gtmEventData
  } = t0;
  const isDesktop = useDeviceType();
  const [openBadgeModal, setOpenBadgeModal] = useState(false);
  let t1;
  if ($[0] !== gtmEventData || $[1] !== isFCCMember) {
    t1 = isFCCMember && <div className="flex items-center gap-2" onClick={() => {
      setOpenBadgeModal(true);
      pushGtmEvent({
        event_name: "contractor_profile_page_action_taken",
        event_action: "fcc_badge_clicked",
        ...gtmEventData
      });
    }}><IconButton className="mr-1 sm:mr-3" sx={{
        padding: "2px"
      }}><div className="w-[28px] h-[28px] flex justify-center items-center rounded-[4px] bg-gradient-to-b from-[#F26422] to-[#EC1E22] border-[2px] border-[#EC9468] "><div className="w-[24px] h-[24px]  relative"><Image priority={true} src="/assets/fcc.svg" layout="fill" className="object-cover " sizes="100%" alt="fcc logo" /></div></div></IconButton><div className="text-[--textWarningWarning]"><p className="m3-label-large">Verified FCC member</p></div></div>;
    $[0] = gtmEventData;
    $[1] = isFCCMember;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex md:gap-2">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpenBadgeModal(false);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== digitalProfile) {
    t4 = <FccBottomSheet digitalProfile={digitalProfile} />;
    $[6] = digitalProfile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isDesktop || $[9] !== openBadgeModal || $[10] !== t4) {
    t5 = <BottomSheet isDesktop={isDesktop} maxWidth="md" open={openBadgeModal} onClose={t3} bgColor={colorSurfaceSurface}>{t4}</BottomSheet>;
    $[8] = isDesktop;
    $[9] = openBadgeModal;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default FccModal;